"use client"

import { useQuery } from "@tanstack/react-query"
import {
  getEmailClassifierConfigAction,
  type EmailClassifierConfigView,
} from "@/server-actions/email-classifier-config"

export const emailClassifierConfigQueryKey = (agentId: string) =>
  ["email-classifier-config", agentId] as const

/** Effective classifier config (prompt + categories) for an email agent. */
export function useEmailClassifierConfigQuery(agentId: string | null) {
  return useQuery<EmailClassifierConfigView>({
    queryKey: emailClassifierConfigQueryKey(agentId ?? ""),
    enabled: Boolean(agentId),
    queryFn: async () => {
      const result = await getEmailClassifierConfigAction({ agent_id: agentId as string })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
